import { CaseStudyPage, type CaseStudyData } from "@/components/CaseStudyTemplate";
import { CheckCircle, TrendingUp, Bot, Globe, MessageSquare } from "lucide-react";

const data: CaseStudyData = {
  seoTitle: "JC Training & Development Case Study | Coach Funnel & AI | Frayze",
  seoDescription: "See how Frayze gave JC Training a new authority site, SEO, and AI-powered outreach that captures and books leads around the clock.",
  seoKeywords: "coach marketing, sales training website, AI chatbot for coaches, sales funnel Myrtle Beach, JC Training success story",
  canonical: "https://frayze.ca/case-studies/jc-training-professional-services/",
  breadcrumbs: [
    { name: "Home", item: "https://frayze.ca/" },
    { name: "Case Studies", item: "https://frayze.ca/case-studies/" },
    { name: "JC Training & Development", item: "https://frayze.ca/case-studies/jc-training-professional-services/" },
  ],

  industry: "Professional Services",
  industryColor: "blue",
  clientName: "JC Training & Development",
  headline: (
    <>
      <span className="text-blue-400">AI-Powered</span> Lead Gen & <span className="text-blue-400">Expert Funnel</span> for a National Sales Coach
    </>
  ),
  stats: [
    { value: "New", label: "Authority Site" },
    { value: "AI", label: "Outreach & Chat" },
    { value: "#1", label: "Expert Positioning" },
    { value: "24/7", label: "Lead Capture" },
  ],

  client: "Joseph Acala / JC Training",
  industryLabel: "Sales Training & Coaching",
  location: "Myrtle Beach, SC",
  services: "Website, AI Automation, SEO, Socials",
  website: "josephacala.com",

  sections: [
    {
      title: "The Challenge",
      content: "Joseph Acala is a high-performance sales coach, but his digital presence wasn't reflecting his expert status. He needed a central hub that could not only showcase his authority but also actively hunt for and capture new leads using modern technology.",
      bullets: [
        "<strong>Outdated Brand Hub:</strong> His existing presence was fragmented and didn't convey the premium value of his coaching.",
        "<strong>Manual Prospecting:</strong> Lead generation was a manual, time-consuming process that limited his ability to scale.",
        "<strong>Ghosted Leads:</strong> Prospects visiting his site or socials often didn't receive an instant response, leading to lost opportunities.",
      ],
    },
    {
      title: "The System We Installed",
      content: "Frayze built a brand new website and integrated a full-spectrum AI outreach and lead generation engine.",
    },
    {
      title: "1. Brand New Authority Website",
      content: "We designed and launched josephacala.com as a high-performance brand hub. The site is optimized for SEO and conversion, positioning Joseph as the clear authority in automotive sales training.",
    },
    {
      title: "2. AI Chatbot & Responders",
      content: "We deployed an AI chatbot trained on Joseph's specific sales methodology. It identifies visitors, answers questions, and books appointments 24/7, ensuring no lead is ever left waiting.",
    },
    {
      title: "3. AI Outreach & Lead Gen",
      content: "We built an automated AI outreach system that targets high-value prospects on LinkedIn and beyond. The system initiates conversations, qualifies interest, and brings warm leads directly to Joseph's inbox.",
    },
    {
      title: "4. Social Media & SEO",
      content: "We manage his SEO and social media presence (LinkedIn, Instagram, etc.) to ensure consistent brand messaging and a steady stream of organic traffic to the new expert funnel.",
    },
  ],

  results: [
    { icon: Bot, label: "AI Outreach Engine", sublabel: "Automated lead hunting and qualification" },
    { icon: MessageSquare, label: "AI Chatbot", sublabel: "24/7 responder and appointment setter" },
    { icon: Globe, label: "Authority Branding", sublabel: "Brand new site and SEO dominance" },
    { icon: CheckCircle, label: "Social Management", sublabel: "LinkedIn and social expansion managed" },
  ],

  stack: ["Custom Brand Hub", "AI Chatbot", "AI Outreach System", "LinkedIn Automation", "Local SEO", "GoHighLevel CRM"],
};

const JCTrainingPage = () => <CaseStudyPage data={data} />;
export default JCTrainingPage;
